<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<br/>
		<v-btn @click="exportData" color="primary" dark class="mb-2">Eksportuj</v-btn>

		<v-dialog v-model="editDialog" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Zmiana adresu e-mail</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12>
								<v-form ref="form">
									<v-text-field
										browser-autocomplete="off"
										data-vv-name="email"
										data-vv-as="E-mail"
										:error-messages="vErrors.collect('email')"
										label="Nowy e-mail"
										aria-label="email"
										for="unconfirmed-user-email"
										id="unconfirmed-user-email"
										v-model="editedItem.email"
										v-validate="'required|email'"
										data-vv-validate-on="none"
									></v-text-field>
								</v-form>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="editDialog = false">Anuluj</v-btn>
					<v-btn color="primary" flat @click="saveEmail" v-if="editedItem.email">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-data-table
			:headers="tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.email }}</td>
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.surname }}</td>
				<td>{{ props.item.role }}</td>
				<td>{{ props.item.registrationDate }}</td>
				<td>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="resendEmail(props.item)" >
								<v-icon v-on="on">
									redo
								</v-icon>
							</v-btn>
						</template>
						<span>Wyślij ponownie</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="openEditDialog(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Zmień e-mail</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deleteItem(props.item)" >
								<v-icon v-on="on" color="lightred">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "../../../../api";
	import {encoder} from "../../../../utils/encodeHelper";
	import {ExportUtils} from "../../../../utils/ExportUtils";
	import {UnconfirmedUser} from "../../../../api/generated/UnconfirmedUser";
	import {UserRegister} from "../../../../api/generated/UserRegister";

	export default {

		name: "UnconfirmedUsersTable",

		mounted () {
			this.removeEmptyTableLoading();
		},


		data() {
			return {
				loading: false,
				users: [],
				tableHeaders: [
					{
						text: "E-mail",
						sortable: true,
						value: "email"
					},
					{
						text: "Imię",
						sortable: true,
						value: "firstName"
					},
					{
						text: "Nazwisko",
						sortable: true,
						value: "secondName"
					},
					{
						text: "Rola",
						sortable: true,
						value: "role"
					},
					{
						text: "Data rejestracji",
						sortable: true,
						value: "registrationDate"
					},
					{
						text: "Akcje",
						sortable: false,
					}

				],
				dataTable: {
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
					},
					search: "",
				},

				editedIndex: -1,
				editDialog: false,
				emailToBeChanged: "",
				editedItem: {},
			};
		},

		watch: {

			editDialog(val) {
				if (!val) {
					this.editedIndex = -1;
					this.editedItem = {};
					this.emailToBeChanged = "";
				}
			},

			"dataTable.pagination": {
				handler() {
					this.getItemList();
				},
				deep: true
			}
		},


		computed: {

			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		methods: {

			resetSearch() {
				this.clearFields();
				this.dataTable.search = "";
				this.getItemList();
			},

			clearFields() {
			},

			/* eslint-disable */
			buildSearch(searchFields) {
				let search = "";
				return search;
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},


			exportData () {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let sort = this.buildSort();
				let path = "/unconfirmed-user/export?search=" + this.dataTable.search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList() {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let sort = this.buildSort();
				Api.get(this,
					"/unconfirmed-user/list?search=" + this.dataTable.search
					+ "&page=" + this.dataTable.pagination.page
					+ "&result=" + this.dataTable.pagination.rowsPerPage
					+ "&sort=".concat(sort), response => {
						this.dataTable.itemList = response.itemList;
						this.dataTable.itemCount = response.itemCount;
					});
			},

			discardDuplicateNameError() {
				this.showDuplicateNameMessage = false;
			},

			resendEmail(item) {
				this.$confirm('Czy na pewno chcesz wysłać ponownie email weryfikacyjny?', {
					color: 'info',
					icon: 'warning',
					title: 'Email weryfikacyjny',
					width: 500
				})
					.then(res => {
						if (res) {
							Api.get(this, "/user-register/resend-email".concat("?email=").concat(encoder.encodeUrlParam(item.email)), () => {
								this.$messagesBus.$emit("success", "Email weryfikacyjny został pomyślnie wysłany");
							});
						}
					});
			},

			deleteItem(item) {
				this.$confirm('Czy na pewno chcesz usunąć użytkownika?', {
					color: "lightred",
					icon: 'delete',
					title: 'Usuwanie użytkownika',
					width: 500
				})
					.then(res => {
						if (res) {
							const index = this.dataTable.itemList.indexOf(item);
							UnconfirmedUser.delete(this, encoder.encodeUrlParam(item.email), successResponse => {
								this.$messagesBus.$emit("success", "Użytkownik został pomyślnie usunięty", successResponse);
								this.dataTable.itemList.splice(index, 1);
							}, errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się usunąć użytkownika", errorResponse);
							});
						}
					});
			},

			openEditDialog(item) {
				this.emailToBeChanged = item.email;
				this.editedIndex = this.dataTable.itemList.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.editDialog = true;
			},

			saveEmail() {
				this.$validator.validateAll().then((result) => {
					if (!result) {
						return;
					}
					if (this.emailToBeChanged === this.editedItem.email) {
						this.$messagesBus.$emit("error", "Podany adres e-mail jest identyczny z obecnym");
						return;
					}
					UserRegister.postChangeEmail(this, encoder.encodeUrlParam(this.emailToBeChanged), encoder.encodeUrlParam(this.editedItem.email), successResponse => {
						this.editDialog = false;
						this.$messagesBus.$emit("success", "Adres e-mail został pomyślnie zmieniony. Wiadomość mailowa o rejestracji konta w systemie została wysłana.", successResponse);
						this.getItemList();
					}, errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.status === "NOT_ACCEPTABLE" ?
							errorResponse.message : "Nie udało się zmienić adresu e-mail", errorResponse);
					});
				});
			},

			close() {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
			},
			removeEmptyTableLoading () {
				var el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},

		},
	};
</script>

<style scoped>

</style>
